export default __webpack_public_path__ + "static/media/lumaki.dc003d69.svg";